var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.33333C0.75 4.38754 0.750583 3.7233 0.792923 3.20508C0.834548 2.69562 0.912761 2.39369 1.03157 2.16052C1.27924 1.67444 1.67444 1.27924 2.16052 1.03157C2.39369 0.912761 2.69562 0.834548 3.20508 0.792923C3.7233 0.750583 4.38754 0.75 5.33333 0.75H14.6667C15.6125 0.75 16.2767 0.750583 16.7949 0.792923C17.3044 0.834548 17.6063 0.912761 17.8395 1.03157C18.3256 1.27924 18.7208 1.67444 18.9684 2.16052C19.0872 2.39369 19.1655 2.69562 19.2071 3.20508C19.2494 3.7233 19.25 4.38754 19.25 5.33333V14.6667C19.25 15.6125 19.2494 16.2767 19.2071 16.7949C19.1655 17.3044 19.0872 17.6063 18.9684 17.8395C18.7208 18.3256 18.3256 18.7208 17.8395 18.9684C17.6063 19.0872 17.3044 19.1655 16.7949 19.2071C16.2767 19.2494 15.6125 19.25 14.6667 19.25H5.33333C4.38754 19.25 3.7233 19.2494 3.20508 19.2071C2.69562 19.1655 2.39369 19.0872 2.16052 18.9684C1.67444 18.7208 1.27924 18.3256 1.03157 17.8395C0.912761 17.6063 0.834548 17.3044 0.792923 16.7949C0.750583 16.2767 0.75 15.6125 0.75 14.6667V5.33333Z",
    stroke: "#ACB6C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.1f7dc99ac3bec2f1c22f101ecb3ebcd9.svg";
export { ForwardRef as ReactComponent };